import { useState } from "react";

export default function LoginForm({ onSubmit, status, disabled }) {
  // [ ] remove hard coded login credentials
  const [email, setEmail] = useState("davidal@citywit.com");
  const [password, setPassword] = useState("David@Broderick70!");
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);
  // const [success, setSuccess] = useState(null);

  const submit = (e) => {
    e.preventDefault();
    onSubmit({ email, password }); // parent handles loading/error/success
  };

  // previous code
  // ✅ Call hook at top level (once per render)
  // const login = useUserLogin();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   setLoading(true);
  //   setError(null);
  //   setSuccess(null);

  //   try {
  //     // login() returns the server JSON (e.g., { success, message, data })
  //     const result = await login({ email, password });

  //     if (result?.success) {
  //       setEmail("");
  //       setPassword("");
  //       setSuccess(
  //         result.message ||
  //           "Login Successful. Look for a confirmation email we just sent to validate your email."
  //       );
  //     } else {
  //       // If your API always uses HTTP errors for failures, this branch may never run
  //       setError(result?.message || "Login failed");
  //     }
  //   } catch (err) {
  //     setError(err.message || "Login failed");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <form onSubmit={submit} className="p-4 border rounded">
      <div
        className="tab-pane fade fade show active"
        id="pills-profile"
        role="tabpanel"
        aria-labelledby="pills-profile-tab"
      >
        <div className="form px-4">
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            className="form-control mt-2"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <div className="text-muted mb-2 mt-2">
            <a
              href="/password/reset"
              className="small text-muted"
              tabIndex="-1"
            >
              Forgot Password?
            </a>
          </div>
          <button
            className="submit btn btn-bg w-100"
            type="submit"
            disabled={disabled}
          >
            {status.loading ? "Logging in..." : "Login"}
          </button>
          {status?.error && <p className="text-danger mt-2">{status.error}</p>}
          {status?.success && (
            <div className="text-success mt-2">{status.success}</div>
          )}
        </div>
      </div>
    </form>
  );
}

// 8/28/25 Old code before using hooks and useUserLogin hoke
// const LoginForm = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault(); // prevent default form submission refresh

//     setLoading(true);
//     setError(null);
//     setSuccess(null);

//     try {
//       // const loginResult = await userLogin({ email, password });
//       const loginResult = useUserLogin();
//       // ...
//       await loginResult({ email, password });

//       if ("success" in loginResult && loginResult.success === true) {
//         // --- SUCCESS: clear form fields ---
//         setEmail("");
//         setPassword("");

//         // --- SUCCESS: show message ---
//         // window.location.href = "/";
//         // setSuccess(
//         //   "Registration successful! Before you can log in, you will need to validate your email address by clicking the confirm link we just sent you."
//         // );

//         //send confirm email message with verify url
//         // const registrationConfirmationLink = loginResult.data.emailVerifyUrl;
//       }
//       console.log("result:", loginResult);
//       setSuccess("Login Successful");
//     } catch (err) {
//       console.error(err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
// <form onSubmit={handleSubmit} className="p-4 border rounded">
//   <div
//     className="tab-pane fade fade show active"
//     id="pills-profile"
//     role="tabpanel"
//     aria-labelledby="pills-profile-tab"
//   >
//     <div className="form px-4">
//       <input
//         type="email"
//         className="form-control"
//         placeholder="Email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         required
//       />
//       <input
//         type="password"
//         className="form-control"
//         placeholder="Password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         required
//       />
//       <div className="mb-2">
//         <a
//           href="/password/reset"
//           className="small text-muted"
//           tabIndex="-1"
//         >
//           Forgot Password?
//         </a>
//       </div>
//           <button
//             className="btn btn-dark w-100"
//             type="submit"
//             disabled={loading}
//           >
//             {loading ? "Logging in..." : "Login"}
//           </button>
//           {/* Error message */}
//           {error && <div className="text-danger mt-2">{error}</div>}
//           {/* Success message */}
//           {success && <div className="text-success mt-2">{success}</div>}
//         </div>
//       </div>
//     </form>
//   );
// };

// export default LoginForm;

/*
// <div className="login-container custom-wrapper">
    //   <form id="login_form" className="pure-form pure-form-stacked" onSubmit={handleSubmit}>
    //     <fieldset>
    //       <legend>Login</legend>

    //       <label htmlFor="login_email">Email</label>
    //       <input
    //         id="login_email"
    //         type="email"
    //         placeholder="Email"
    //         size={35}
    //         value={email}
    //         onChange={(e) => setEmail(e.target.value)}
    //         required
    //       />
    //       <span className="pure-form-message">This is a required field.</span>

    //       <label htmlFor="login_password">Password</label>
    //       <input
    //         id="login_password"
    //         type="password"
    //         placeholder="Password"
    //         size={35}
    //         value={password}
    //         onChange={(e) => setPassword(e.target.value)}
    //         required
    //       />

    //       <button type="submit" className="pure-button pure-button-primary">
    //         Sign in
    //       </button>
    //     </fieldset>
    //   </form>
    // </div>
*/
